module.exports = __webpack_public_path__ + "img/bg.436a67b7.png";